import React, { useEffect, useState } from 'react'
import styles from '../../../../styles/modules/ParticipantFee.module.css'
import ParticipantFeeCard from './ParticipantFeeCard'
import CustomDialog from '../../../CustomComponents/CustomDialog/CustomDialog'
import { Alert, FormControlLabel, Menu, MenuItem, Radio, RadioGroup, Switch, TextareaAutosize, TextField } from '@mui/material'
import { FormTemplateAPI } from '../../../../api/FormTemplateAPI'
import { useSelector } from 'react-redux';
import Loader from '../../../../component/Loader.jsx'
import { MdOutlineModeEditOutline } from 'react-icons/md'
import { AiTwotoneDelete } from 'react-icons/ai'
import { Privileges } from '../../../../util/PrivilegeConstants.js'
import * as Yup from 'yup'
import { isClubOwner } from '../../../../util/UserRoles.js'
import { useDispatch } from 'react-redux'
import { rootAction } from '../../../../redux/reducer/rootReducer.js'

const initialValue = {
  criteria: '',
  description: '',
  feeAmount: ''
}

const ParticipantFee = ({ formTemplateId, privileges, formtemplateStatus }) => {
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const userInfo = useSelector((store) => store.user.userInfo);
  const [openPopup, setOpenPopup] = useState({ isOpen: false, isEdit: false });
  const [participantFeeList, setParticipantFeeList] = useState([]);
  const [selectedParticipantFee, setSelectedParticipantFee] = useState([]);
  const [pfData, setPfData] = useState(initialValue);
  const [isLoading, setIsLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isCustomAmount, setIsCustomAmount] = useState(false);
  const dispatch = useDispatch();

  const validationObj = Yup.object({
    criteria: Yup.string().required("Name is required").max(300, "Name must not exceed 300 characters."),
    feeAmount: !isCustomAmount && Yup.number().typeError("Amount should be a valid number.").required("Amount is required"),
    description: Yup.string().max(1000, "Description must not exceed 1000 characters.")
  });



  const handleCollectData = (event) => {
    const { name, value } = event.target;
    setPfData({ ...pfData, [name]: value });
  };
  const handleSelectParticipantFee = (pf, val) => {
    setSelectedParticipantFee(prev => {
      let newList = [...prev];
      if (val) {
        const isExist = newList.some(item => item.id === pf.id);
        if (!isExist) {
          newList.push(pf);
        }
      } else {
        newList = newList.filter(item => item.id !== pf.id)
      }
      return newList;
    })
  };

  const handleAddParticipantFeeIntoFormTemplate = async () => {
    try {
      setIsLoading(true);
      await FormTemplateAPI.postAddParticipantFeeIntoFormTemplate({
        formTemplateId: formTemplateId,
        participantIds: selectedParticipantFee.map(item => item.id)
      })
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Participants Fee updated successfully' }));
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddParticipantFee = async () => {
    try {
      await validationObj.validate(pfData, { abortEarly: false });
      setIsLoading(true);
      const response = await FormTemplateAPI.postAddParticipantFee({
        clubId: selectedClub.clubId,
        criteria: pfData.criteria,
        description: pfData.description,
        feeAmount: pfData.feeAmount,
        isCustomAmount: isCustomAmount
      });
      setParticipantFeeList([...participantFeeList, response.Data]);
      setOpenPopup({ isOpen: false, isEdit: openPopup.isEdit });
      setPfData(initialValue);
      setFieldErrors({});
    } catch (error) {
      console.log(error);
      if (error?.inner) {
        let errorObj = {}
        error.inner.forEach(err => {
          errorObj[err.path] = err.message;
        })
        setFieldErrors(errorObj)
      }
    } finally {
      setIsLoading(false);
    }
  };
  const deleteParticipantFee = async (id) => {
    try {
      setIsLoading(true)
      await FormTemplateAPI.deleteParticipantFee({
        id: id,
        clubId: selectedClub.clubId
      });
      setParticipantFeeList(prev => prev.filter(item => item.id != id));
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleUpdateParticipantFee = async () => {
    try {
      await validationObj.validate(pfData, { abortEarly: false });
      setIsLoading(true);
      const response = await FormTemplateAPI.putUpdateParticipantFee({
        id: pfData.id,
        criteria: pfData.criteria,
        description: pfData.description,
        feeAmount: pfData.feeAmount,
        isCustomAmount: isCustomAmount
      });
      setParticipantFeeList(participantFeeList.map(item => item.id === pfData.id ? { ...item, criteria: pfData.criteria, description: pfData.description, feeAmount: pfData.feeAmount } : item));
      setOpenPopup({ isOpen: false, isEdit: openPopup.isEdit });
      setPfData(initialValue);
      setFieldErrors({});
    } catch (error) {
      console.log(error);
      if (error?.inner) {
        let errorObj = {}
        error.inner.forEach(err => {
          errorObj[err.path] = err.message;
        })
        setFieldErrors(errorObj)
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getAllParticipantFee = async () => {
    try {
      setIsLoading(true);
      const response = await FormTemplateAPI.getAllParticipantFee(selectedClub.clubId);
      setParticipantFeeList(response.Data)
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getAllSelectedParticipantFee = async () => {
    try {
      setIsLoading(true);
      const response = await FormTemplateAPI.getAllSelectedParticipantFee(formTemplateId);
      setSelectedParticipantFee(response.Data)
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (selectedClub.clubId) {
      getAllParticipantFee();
      getAllSelectedParticipantFee();
    }
  }, [selectedClub.clubId]);

  const handleOpenEditPopup = (data) => {
    setOpenPopup({ isOpen: true, isEdit: true });
    setPfData(data)
  };

  return (
    <div className={styles['participant_fee_container']}>
      {isLoading && <Loader />}
      <div className={styles['participant_fee_header']}>
        <h2>Participant Fees</h2>
        {(privileges?.MANAGE_PARTICIPANT_FEE?.includes(Privileges.CREATE) && (formtemplateStatus === 'IN_PROGRESS' || isClubOwner(userInfo))) &&
          <button onClick={() => setOpenPopup({ isOpen: true, isEdit: false })}>Add Participant Fee</button>
        }
      </div>
      <Alert sx={{
        margin: '22px 0', border: '2px solid var(--hoverColorBold)',
        borderRadius: 2,
        '& .MuiAlert-icon': {
          color: 'var(--hoverColorBold)',
        },
      }} variant='outlined' severity='info' >
        Select one or multiple participant fee from the list that you want to add to your form template.To add more participant fee, click the 'Add Participant Fee' button above.
      </Alert>
      <div className={styles['participant_fee_card_list']}>
        {
          participantFeeList?.map((pf) =>
            <ParticipantFeeCard
              formtemplateStatus={formtemplateStatus}
              handleOpenEditPopup={handleOpenEditPopup}
              key={pf.id}
              userInfo={userInfo}
              participantFee={pf}
              handleSelectParticipantFee={handleSelectParticipantFee}
              selectedParticipantFee={selectedParticipantFee}
              privileges={privileges}
              deleteParticipantFee={deleteParticipantFee}
            />
          )
        }
      </div>
      {(participantFeeList?.length != 0 && privileges?.MANAGE_PARTICIPANT_FEE?.includes(Privileges.MODIFY) && (formtemplateStatus === 'IN_PROGRESS' || isClubOwner(userInfo))) &&
        <div className={styles['participant_fee_save_btn']}>
          <button onClick={handleAddParticipantFeeIntoFormTemplate} type='button'>Save</button>
        </div>}
      <CustomDialog
        title={"Participant Fee Details"}
        isOpen={openPopup.isOpen}
        onClose={() => setOpenPopup({ isOpen: false, isEdit: openPopup.isEdit })}
        onCancel={() => {
          setOpenPopup({ isOpen: false, isEdit: openPopup.isEdit });
          setPfData(initialValue);
          setFieldErrors({})
        }}
        onSubmit={() => {
          if (openPopup.isEdit) {
            handleUpdateParticipantFee();
          } else {
            handleAddParticipantFee()
          }
        }}
      >
        <div className={styles['participant_fee_form']}>
          <TextField
            error={fieldErrors['criteria']}
            helperText={fieldErrors['criteria'] && fieldErrors['criteria']}
            value={pfData.criteria}
            onChange={handleCollectData}
            className={styles['participant_form_text_field_theme']}
            label='Name' name='criteria' />
          <div className="agree-term-for-save-card">
            <Switch checked={isCustomAmount} onClick={() => setIsCustomAmount(!isCustomAmount)} color="primary" />
            <div>Let the user enter an amount</div>
          </div>
          {!isCustomAmount &&
          <TextField
            error={fieldErrors['feeAmount']}
            helperText={fieldErrors['feeAmount'] && fieldErrors['feeAmount']}
            name='feeAmount'
            value={pfData.feeAmount}
            onChange={handleCollectData}
            className={styles['participant_form_text_field_theme']}
            label="Fee" />}
          <TextField
            error={fieldErrors['description']}
            helperText={fieldErrors['description'] && fieldErrors['description']}
            value={pfData.description}
            onChange={handleCollectData}
            name='description'
            className={styles['participant_form_text_field_theme']}
            label="Description"
            multiline
            maxRows={10}
            variant="outlined"
          />
        </div>
      </CustomDialog>
    </div>
  )
}

export default ParticipantFee